import { render, staticRenderFns } from "./breadcumb.vue?vue&type=template&id=49372184&scoped=true&"
import script from "./breadcumb.vue?vue&type=script&lang=js&"
export * from "./breadcumb.vue?vue&type=script&lang=js&"
import style0 from "./breadcumb.vue?vue&type=style&index=0&id=49372184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49372184",
  null
  
)

export default component.exports